module.exports = __webpack_public_path__ + "static/media/r18.19f8da70.jpg";